import { useTranslation } from 'react-i18next'
import i18next from 'i18next'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
import { Box, Typography } from '@mui/material'

import { useUser } from 'store'
import { SideContent } from 'components-shared'
import CardActionButton from 'components/global/CardActions/CardActionButton'
import CardPreview from 'packages/ui/CardPreview/CardPreview'

import { useAdvertisement } from '../use-advertisements'
import Body from './Body'
import { TagAdvertisements } from '../TagAdvertisements'

const Header = ({ advertisement }) => {
  return (
    <Box display={'flex'} flexDirection={'column'} alignItems={'center'} gap={0.5} mt={2} mb={2}>
      <TagAdvertisements status={advertisement.status} />
      <Typography fontWeight={500} fontSize={'16px'}>
        {advertisement.name}
      </Typography>
      <Box display={'flex'} alignItems={'center'} gap={0.5} color={'#A2AAB8'}>
        <i className="fa-regular fa-calendar-range fa-xs" />
        <Typography fontWeight={400} fontSize={12} color={'#7A8096'}>
          {`${new Date(advertisement.starts_at).toLocaleDateString(i18next.language)} au ${new Date(
            advertisement.ends_at
          ).toLocaleDateString(i18next.language)}`}
        </Typography>
      </Box>
    </Box>
  )
}

const Card = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const location = useLocation()
  const { id } = useParams()
  const { advertisement, loading } = useAdvertisement({ id })
  const [user] = useUser()
  return (
    <SideContent>
      <CardPreview
        title={t('ui_elements.card_title')}
        onClose={() => navigate({ pathname: '..' })}
        loading={loading}
        components={{
          ActionButtons: advertisement?.can_be_edit ? () => (
            <>
              <CardActionButton
                tooltiptitle={t('advertisements.table.tooltip_edit_button')}
                iconlabel={'pen'}
                disabled={Boolean(user.demo_mode)}
                onClick={() => navigate(`${location.pathname}/edit`)}
              />
              <CardActionButton
                tooltiptitle={t('advertisements.table.tooltip_delete_button')}
                iconlabel={'trash'}
                disabled={Boolean(user.demo_mode)}
                onClick={() => navigate(`${location.pathname}/delete`)}
              />
            </>
          ) : null
        }}>
        <Header advertisement={advertisement} />
        <Body advertisement={advertisement} />
      </CardPreview>
      <Outlet />
    </SideContent>
  )
}

export default Card
